var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal pb-4"},[(_vm.isLoading)?_c('div',[_vm._v("\n        Loading...\n    ")]):_c('div',{domProps:{"innerHTML":_vm._s(_vm.legalContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }